import { ReactNode, useId } from "react";
import s from "./Card.module.scss";

export const Card = ({ title, actions, flush, children, as: Tag = "section" }:
  { title?: ReactNode; actions?: ReactNode; flush?: boolean; children: ReactNode; as?: "section" | "div" }) => {
  const id = useId();
  return (
    <Tag className={`${s.card} ${flush ? s.flush : ""}`} aria-labelledby={title ? id : undefined} role={Tag === "section" && title ? "region" : undefined}>
      {(title || actions) && (
        <header className={s.head}>
          {title && <h2 id={id} className={s.title}>{title}</h2>}
          {actions && <div className={s.actions}>{actions}</div>}
        </header>
      )}
      <div className={s.body}>{children}</div>
    </Tag>
  );
};
